<template>
  <DataList
    title="Блоки"
    resource="document-blocks"
    :headers="headers"
    :filter="filter"
    high-block
    :add-route="{ name: 'gen-doc-blocks' }"
  >
    <template v-slot:filters>
      <v-row no-gutters>
        <v-col
          md="12"
          sm="12"
        >
          <SelectTags
            v-model="tags"
            :multiple-select="true"
            class="my-4 mx-1"
          />
        </v-col>
      </v-row>
    </template>
  </DataList>
</template>

<script>
import DataList from "../../components/DataList.vue";
import SelectTags from "../tags/SelectTags.vue";
import * as tagsApi from "../../backend/tagsApi.js";

export default {
  components: {
    DataList,
    SelectTags,
  },
  data: () => ({
    headers: [
      {
        text: "Атомарний блок",
        component: "DocumentBlocksItem",
        sortable: false,
        width: "100%",
      },
      {
        text: "",
        name: "content",
        type: "preview",
        sortable: false,
      },
      {
        text: "",
        type: "action",
        sortable: false,
      },
    ],
    tags: [],
  }),
  computed: {
    filter() {
      return {
        tags: this.tags,
      };
    },
  },
  created() {
    this.getTags();
  },
  methods: {
    async getTags() {
      const query = this.$router.currentRoute.query?.tags;
      if (!query) {
        return;
      }
      if (Array.isArray(query)) {
        for (let i = 0; i < query.length; i++) {
          this.tags.push(await tagsApi.getTag(query[i]));
        }
      } else {
        this.tags.push(await tagsApi.getTag(query));
      }
    },
  },
};
</script>

<style lang="scss">
.document-blocks, .block-preview {
  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    overflow: hidden;

    td,
    th {
      min-width: 1em;
      border: 2px solid #ced4da;
      padding: 3px 5px;
      vertical-align: top;
      box-sizing: border-box;
      position: relative;

      > * {
        margin-bottom: 0;
      }
    }

    th {
      font-weight: bold;
      text-align: left;
      background-color: #f1f3f5;
    }

    p {
      margin: 0;
    }
  }
}

.resize-cursor {
  cursor: row-resize;
}
</style>